import { AxiosResponse } from 'axios';
import { getEntry, putEntry } from './db';
import { AxiosResponseOk } from './http-responses';
import { connection } from './internet';
import { session } from './session';


interface CacheEntry {
  keyPath: string;
  accountId: string;
  args: Array<string>;
  result: any;
}

export class OfflineCacheMissError extends Error {
  constructor(objectStore: string, args: unknown[]) {
    super(`No cached data for offline request to ${objectStore} (${JSON.stringify(args)})`);
    this.name = 'OfflineCacheMissError';
  }
}

async function getKeypath(args) {
  if (!session.account) throw new OfflineCacheMissError('session', args);
  return [
    session.account.id,
    ...args,
  ].map(e => e.toString()).join('@');
}

async function cacheResult(objectStore, args, result) {
  if (!session.account) return;
  await putEntry<CacheEntry>(objectStore, {
    keyPath: await getKeypath(args),
    args: args,
    accountId: session.account.id,
    result,
  });
}

async function retrieveCachedEntry(objectStore, args) {
  if (!session.account) return undefined;
  return await getEntry<CacheEntry>(objectStore, await getKeypath(args));
}

async function getRemoteOrLocal<T>(objectStore, remoteFn , ...args) {
  if (connection.isConnected.value) {
    const result = await remoteFn(...args) as AxiosResponse<T>;
    if (result) {
      await cacheResult(objectStore, args, result.data);
      return result;
    }
  }

  const cacheEntry = await retrieveCachedEntry(objectStore, args);
  if (!cacheEntry) throw new OfflineCacheMissError(objectStore, args);
  return new AxiosResponseOk(cacheEntry.result);
}

export { getRemoteOrLocal }
